import { EventValues } from '@shared/privacy/enums';

export const EVENTS = [
  EventValues.lastLogin,
  EventValues.dataCreated,
];
